import {defineMessages} from 'react-intl';

export default defineMessages({
  editTooltipMessage: {
    defaultMessage: 'Edit',
    id: 'DiscussPage.AnswersSection.UserAnswer.EditTooltipMessages',
  },
});
